import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords = '', 
  image = '',
  url = '',
  type = 'website' 
}) => {
  const defaultTitle = 'TerraNova Consulting - Geotechnical Engineering Excellence';
  const defaultDescription = 'Professional geotechnical engineering services including site investigation, slope stability analysis, foundation engineering, and environmental consulting.';
  const defaultKeywords = 'geotechnical engineering, site investigation, slope stability, foundation engineering, soil analysis, TerraNova consulting';
  const siteUrl = 'https://TerraNovaconsulting.com'; // Replace with your actual domain

  const seoTitle = title ? `${title} | TerraNova Consulting` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;
  const seoUrl = url ? `${siteUrl}${url}` : siteUrl;
  const seoImage = image || `${siteUrl}/logo-social.png`; // Add your social media image

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="TerraNova Consulting" />

      {/* Additional Meta Tags */}
      <meta name="author" content="TerraNova Consulting" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Business specific */}
      <meta name="geo.region" content="US" />
      <meta name="geo.placename" content="Your City, State" />
      <meta name="business.contact_data.country_name" content="United States" />
      <meta name="business.contact_data.email" content="info@TerraNovaconsulting.com" />
      <meta name="business.contact_data.phone_number" content="07700777140" />
    </Helmet>
  );
};

export default SEO;
